import type { PropertiesNullable } from '@@types/helpers'
import type { AttackerKnownTool, Maybe } from '@server/graphql/typeDefs/types'
import EntityBase from './EntityBase'

export default class AttackerKnownToolEntity
  extends EntityBase
  implements PropertiesNullable<AttackerKnownTool>
{
  name: Maybe<string> = null
  url: Maybe<string> = null
  author: Maybe<string> = null

  constructor(data: Partial<AttackerKnownTool>) {
    super()
    Object.assign(this, data)
  }
}
